import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MetaFieldDto } from '../models/meta-field.model';
import { PagedResponse } from '../models/meta-ui.model';
import { environment } from '../../../environments/environment';

@Injectable({
      providedIn: 'root'
})
export class MetaFieldService {
      private readonly baseUrl = `${environment.apiUrl}/api/MetaField`;

      constructor(private http: HttpClient) { }

      // GET: Paginated & Filtered
      getAll(pageIndex: number, pageSize: number, searchTerm: string = ''): Observable<PagedResponse<MetaFieldDto>> {
            const params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString())
                  .set('searchTerm', searchTerm);

            return this.http.get<PagedResponse<MetaFieldDto>>(this.baseUrl, { params });
      }

      // GET: Single by ID
      getById(id: string): Observable<MetaFieldDto> {
            return this.http.get<MetaFieldDto>(`${this.baseUrl}/${id}`);
      }

      // POST: Create
      create(dto: Partial<MetaFieldDto>): Observable<string> {
            return this.http.post<string>(this.baseUrl, dto);
      }

      // PUT: Update
      update(id: string, dto: MetaFieldDto): Observable<boolean> {
            return this.http.put<boolean>(`${this.baseUrl}/${id}`, dto);
      }

      // DELETE
      delete(id: string): Observable<boolean> {
            return this.http.delete<boolean>(`${this.baseUrl}/${id}`);
      }
}